module.exports = __webpack_public_path__ + "static/media/twitter.0df5d187.png";